"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.truncateDecimal = void 0;
var truncateDecimal = function (num, len) {
    if (len === void 0) { len = 2; }
    var numStr = num.toFixed(20);
    var regex = new RegExp("^-?\\d*\\.?0*\\d{0,".concat(len, "}"));
    var match = numStr.match(regex);
    return Number(match ? match[0] : numStr);
};
exports.truncateDecimal = truncateDecimal;
